import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';


const OrganizationDashboardPage = lazy(() => import('src/pages/dashboard/organization-dashboard'));


export const organizationDashboardRoutes: RouteObject[] = [
  {
    path: 'organization-dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <OrganizationDashboardPage />, index: true },
    ],
  },
];
